<section class="widget-section">
  <div class="container-fluid" #heroZoneInfoBoxContainer>
    <app-infobox-zone appMarkComponentVisited area="Hero" [appHideParentIfEmpty]="heroZoneInfoBoxContainer"></app-infobox-zone>
  </div>
</section>

<section class="widget-section order-1" id="app-featured-news">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-featured-news appMarkComponentVisited></app-featured-news>
  </div>
</section>

<section class="widget-section order-2" id="app-my-news">
  <div class="border-top border-bottom border-grey-color" #filterByDepartmentContainer>
    <div class="container pt-3 pb-3 pt-lg-3 pb-lg-3">
      <app-filter-by-department appMarkComponentVisited [appHideParentIfEmpty]="filterByDepartmentContainer"></app-filter-by-department>
    </div>
  </div>
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-my-news></app-my-news>
  </div>
</section>

<section class="widget-section order-3" id="app-organization-calendar">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #organizationCalendarContainer>
    <app-organization-calendar appMarkComponentVisited [appHideParentIfEmpty]="organizationCalendarContainer"></app-organization-calendar>
  </div>
</section>

<section class="widget-section order-4" id="birthday">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg pt-4 pb-4 pt-lg-6 pb-lg-6" #birthdaysContainer *appFeatureToggle="'showBirthdayCalendar'">
        <app-birthdays [appHideParentIfEmpty]="birthdaysContainer"></app-birthdays>
      </div>
      <div class="col-12 col-lg pt-4 pb-4 pt-lg-6 pb-lg-6" #restaurantMenuContainer *appFeatureToggle="'showRestaurantMenus'">
        <app-restaurant-menu [appHideParentIfEmpty]="restaurantMenuContainer"></app-restaurant-menu>
      </div>
    </div>
  </div>
</section>

<section class="widget-section order-5" id="app-rss-feeds">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #rssFeedsContainer>
    <app-rss-feeds [appHideParentIfEmpty]="rssFeedsContainer"></app-rss-feeds>
  </div>
</section>

<section class="widget-section order-6" id="info-box">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #infoBoxContainer>
    <app-infobox-zone appMarkComponentVisited area="Default" [appHideParentIfEmpty]="infoBoxContainer"></app-infobox-zone>
  </div>
</section>

<section class="widget-section order-7" id="app-power-bi">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #powerBIFramesContainer>
    <app-power-bi appMarkComponentVisited [appHideParentIfEmpty]="powerBIFramesContainer"></app-power-bi>
  </div>
</section>

<section class="widget-section order-8" id="app-kpi-charts">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #kpiContainer>
    <app-kpi-charts [appHideParentIfEmpty]="kpiContainer"></app-kpi-charts>
  </div>
</section>



